import { ClientData } from '../models';

export const getSpeedStringFromRawInfo = (appInfo: ClientData): string => {
    const elapsed = appInfo.ElapsedTime / 1e6; /* second */
    let speed = appInfo.NumBytes / elapsed; /* B/s    */
    speed *= 8; /* bit/s  */
    speed /= 1e6; /* Mbit/s */
    return speed.toFixed(3);
};
